'use client';

import { ROUTES } from '@shared/constants/routes';
import { CustomLink } from '@shared/ui/CustomLink';
import { categories } from '@widgets/CategoriesMenu/model/data/data';

import { DOCUMENTS } from '../../constants';
import cls from './NavDesktop.module.scss';

export const NavDesktop = () => {
  return (
    <nav className={cls.wrap}>
      <div className={cls.col}>
        <div className={cls.caption}>
          <span>О нас</span>
        </div>
        <ul className={cls.list}>
          <li className={cls.item}>
            <CustomLink
              aria-label={'Перейти на страницу О компании'}
              className={cls.link}
              href={ROUTES.ABOUT_COMPANY}
            >
              О&nbsp;компании
            </CustomLink>
          </li>
          <li className={cls.item}>
            <CustomLink
              aria-label={'Перейти на страницу Контакты'}
              className={cls.link}
              href={ROUTES.CONTACTS}
            >
              Контакты
            </CustomLink>
          </li>
        </ul>
      </div>
      <div className={cls.col}>
        <div className={cls.caption}>
          <span>Покупателям</span>
        </div>
        <ul className={cls.list}>
          <li className={cls.item}>
            <CustomLink
              aria-label={'Перейти на страницу Доставка и оплата'}
              className={cls.link}
              href={ROUTES.DELIVERY_AND_PAYMENT}
            >
              Доставка и оплата
            </CustomLink>
          </li>
          <li className={cls.item}>
            <CustomLink
              aria-label={'Перейти на страницу Вопрос - ответ'}
              className={cls.link}
              href={ROUTES.QUESTION_ANSWER}
            >
              Вопрос - ответ
            </CustomLink>
          </li>
          <li className={cls.item}>
            <CustomLink
              aria-label={'Перейти на страницу Эксплуатация'}
              className={cls.link}
              href={ROUTES.EXPLOITATION}
            >
              Эксплуатация
            </CustomLink>
          </li>
          <li className={cls.item}>
            <CustomLink
              aria-label={'Перейти на страницу Гарантия'}
              className={cls.link}
              href={ROUTES.WARRANTY}
            >
              Гарантия
            </CustomLink>
          </li>
          <li className={cls.item}>
            <CustomLink
              aria-label={'Перейти на страницу Полезные статьи'}
              className={cls.link}
              href={ROUTES.BLOG}
            >
              Полезные статьи
            </CustomLink>
          </li>
        </ul>
      </div>
      <div className={cls.col}>
        <div className={cls.caption}>
          <span>Каталог</span>
        </div>
        <ul className={cls.list}>
          {categories.map((el) => (
            <li
              key={el.url}
              className={cls.item}
            >
              <CustomLink
                aria-label={`Перейти в каталог на страницу ${el.label}`}
                className={cls.link}
                href={el.url}
              >
                {el.label}
              </CustomLink>
            </li>
          ))}
        </ul>
      </div>

      <div className={cls.col}>
        <div className={cls.caption}>
          <span>Документы</span>
        </div>
        <ul className={cls.list}>
          {DOCUMENTS.map(({ key, label, url }) => (
            <li
              className={cls.item}
              key={key}
            >
              <CustomLink
                aria-label={label}
                className={cls.link}
                href={url}
              >
                {label}
              </CustomLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};
